import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import {
  CalculatorOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  MinusSquareOutlined,
  DownOutlined,
  EditOutlined,
  ExportOutlined,
  FileExcelOutlined,
  MinusCircleOutlined,
  MoreOutlined,
  SearchOutlined,
  SyncOutlined,
  UndoOutlined,
  UsergroupAddOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Typography,
  Card,
  Select,
  Input,
  Radio,
  Button,
  Space,
  Form,
  Table,
  Tooltip,
  Tag,
  Menu,
  Dropdown,
  Modal,
  notification,
  DatePicker,
  Popover,
  Checkbox,
  InputNumber,
} from "antd";
import "../Pages/CSS/Traitement.css";
import { SpecialitesService } from "../Services/SpecialitesService";
import { JournalCentralService } from "../Services/JournalCentralService";
import { ReglementsService } from "../Services/ReglementsService";
import dayjs from "dayjs";
import moment from "moment";
import Draggable from "react-draggable";
const { Option } = Select;

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: "100%", cursor: "move" }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const ReglementFournSoins = () => {
  const initialTableData = [];
  const [specialites, setSpecialites] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedOption, setSelectedOption] = useState("AP");
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const [selectedYear, setSelectedYear] = useState("9999");
  const [years, setYears] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [typeReglementFourn, setTypeReglementFourn] = useState([]);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paramsDetails, setParamsDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [journalBqueData, setJournalBqueData] = useState([]);
  const [journalRegData, setJournalRegData] = useState([]);
  const [isEditingEnabled, setIsEditingEnabled] = useState(false);
  const [isRgFactEnabled, setIsRgFactEnabled] = useState(false);
  const [isComptaEnabled, setIsComptaEnabled] = useState(false);
  const [isAnRegEnabled, setIsAnRegEnabled] = useState(false);
  const [isAnPayeEnabled, setIsAnPayeEnabled] = useState(false);
  const [isPayingEnabled, setIsPayingEnabled] = useState(false);
  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [isOtherButtonsEnabled, setIsOtherButtonsEnabled] = useState(false);
  const [isMassTransferEnabled, setIsMassTransferEnabled] = useState(false);
  const [montantReglement, setMontantReglement] = useState(
    modalData?.montant_reglmt || modalData?.freel || 0
  );

  const [selectedTypeReglement, setSelectedTypeReglement] = useState(null);
  const [isTypeRegDisabled, setIsTypeRegDisabled] = useState(false);
  const [pageSize, setPageSize] = useState(10); // Valeur initiale de pageSize

  const [solde, setSolde] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAnnulationModalOpen, setIsAnnulationModalOpen] = useState(false);
  const [annulationPreviewData, setAnnulationPreviewData] = useState([]);
  const [currentTableData, setCurrentTableData] = useState([]);

  const [form] = Form.useForm();

  const specialitesService = new SpecialitesService();
  const journalCentralService = new JournalCentralService();
  const reglementService = new ReglementsService();

  const fetchYears = async () => {
    try {
      const yearsData = await journalCentralService.getComptaExercices();
      setYears([...yearsData].sort((a, b) => b - a));
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  const fetchReglementations = async () => {
    if (selectedYear && selectedOption) {
      setLoading(true);
      try {
        const data = await reglementService.getReglementations(
          selectedYear,
          selectedOption
        );
        const filteredData = data.filter(
          (item) => item.etape === selectedOption || selectedOption === "TT"
        );
        setTableData(filteredData);
        setFilteredData(filteredData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchYears();
  }, []);

  useEffect(() => {
    fetchReglementations();
  }, [selectedYear, selectedOption]);

  useEffect(() => {
    const total = filteredData.reduce(
      (acc, curr) => acc + parseFloat(curr.montfact || 0),
      0
    );
    setTotalAmount(total);
    setRowCount(filteredData.length);
    setCurrentTableData(filteredData);
  }, [filteredData]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    const currentData = extra.currentDataSource;
    const total = currentData.reduce(
      (acc, curr) => acc + parseFloat(curr.montfact || 0),
      0
    );
    setTotalAmount(total);
    setRowCount(currentData.length);
    setCurrentTableData(currentData);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  useEffect(() => {
    if (specialites.length === 0) {
      specialitesService
        .getAllSpecialites()
        .then((data) => {
          setSpecialites(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }
  }, []);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };

  const fetchJournalBque = async () => {
    try {
      const journalData = await journalCentralService.getAllJournaux();
      setJournalBqueData(journalData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  // Charge les paramètres au montage du composant
  const loadParams = async () => {
    try {
      const data = await reglementService.getParamReg();
      setParamsDetails(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données", error);
    }
  };
  useEffect(() => {
    loadParams();
  }, []);

  useEffect(() => {
    if (paramsDetails && paramsDetails.datedeb) {
      setSelectedDate(dayjs(paramsDetails.datedeb));
    } else {
      setSelectedDate(dayjs());
    }
  }, [paramsDetails]);

  const handleTypeReglementChange = (value) => {
    setSelectedTypeReglement(value);
  };
  const typeReglementLabels = {
    V: "Virement",
    C: "Chèque",
    A: "Pièce Comptable",
    E: "Espèce",
    T: "Transfert",
  };
  useEffect(() => {
    if (selectedDate) {
      form.setFieldsValue({
        datetrait: selectedDate.format("MMM-YYYY"),
      });
    }
  }, [selectedDate, form]);

  useEffect(() => {
    setMontantReglement(modalData?.montant_reglmt || modalData?.freel || 0);
  }, [modalData]);

  const formatNumberWithSeparator = (number) => {
    // Convertit en nombre au cas où l'entrée n'est pas déjà un nombre
    const num = Number(number);
    return num.toLocaleString("fr-FR"); // Utilisez 'fr-FR' ou une autre locale appropriée
  };
  const confirmCancel = (record) => {
    Modal.confirm({
      title: "Êtes-vous sûr d'annuler ce règlement ?",
      content: "Cette action est irréversible. Voulez-vous continuer ?",
      okText: "Oui",
      okType: "danger",
      cancelText: "Non",
      onOk() {
        handleCancelReglement(record); // Appel de la fonction d'annulation
      },
      onCancel() {
        console.log("Annulation de l'action");
      },
    });
  };

  const getConditionalColumns = () => {
    if (selectedOption === "PP" || selectedOption === "CC") {
      return [
        {
          title: "M.P",
          dataIndex: "typereglmt",
          key: "typereglmt",
          align: "center",
          sorter: (a, b) => a.typereglmt.localeCompare(b.typereglmt),
          filters: [
            ...new Set(
              tableData.map((item) => item?.typereglmt).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
            ),
          ].map((value) => ({
            text: value,
            value: value,
          })),
          onFilter: (value, record) => record.typereglmt === value,
          render: (typereglmt) => {
            let color = "";
            let text = "";

            if (typereglmt === "C") {
              color = "#02b4f0";
              text = "C";
            } else if (typereglmt === "P") {
              color = "#02b4f0";
              text = "P";
            } else if (typereglmt === "T") {
              color = "#b5d30e";
              text = "T";
            } else if (typereglmt === "V") {
              color = "rgb(240, 113, 2)";
              text = "V";
            } else if (typereglmt === "E") {
              color = "#b21e1e";
              text = "E";
            } else if (typereglmt === "A") {
              color = "#19e753";
              text = "A";
            }
            return (
              <div style={{ paddingLeft: 10 }}>
                <Tag color={color} key={typereglmt}>
                  {text}
                </Tag>
              </div>
            );
          },
        },

        {
          title: "Date Reg.",
          dataIndex: "datereglmt",
          key: "datereglmt",
          align: "center",
          sorter: (a, b) => a.datereglmt.localeCompare(b.datereglmt),
          render: (text, record) => (
            <div
              style={{
                whiteSpace: "nowrap",
                textAlign: "center",
                paddingLeft: "5px",
                paddingRight: "5px",
              }}
            >
              {moment(text).locale("fr").format("DD/MM/YYYY")}
            </div>
          ),
        },
        {
          title: "N° C/V",
          dataIndex: "numreglmt",
          key: "numreglmt",
          align: "center",
          sorter: (a, b) => a.numreglmt.localeCompare(b.numreglmt),
        },
        {
          title: "Bque.",
          dataIndex: "codebque",
          key: "codebque",
          align: "center",
          sorter: (a, b) => a.codebque.localeCompare(b.codebque),
        },
      ];
    } else {
      return [];
    }
  };

  const baseColumns = [
    {
      title: "N° F.",
      dataIndex: "numenreg",
      key: "numenreg",
      align: "center",
      filterSearch: true,
      filters: [
        ...new Set(
          tableData.map((item) => item?.numenreg).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.numenreg === value,
      sorter: (a, b) => a.numenreg - b.numenreg,
      //   sorter: (a, b) => a.numenreg.localeCompare(b.numenreg),
    },
    {
      title: "N° F. Frs",
      dataIndex: "numfact",
      key: "numfact",
      align: "center",
      filters: [
        ...new Set(
          tableData.map((item) => item?.numfact).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.numfact === value,
      sorter: (a, b) => a.numfact.localeCompare(b.numfact),
    },
    {
      title: "Date fact.",
      dataIndex: "datefact",
      key: "datefact",
      align: "center",
      sorter: (a, b) => a.datefact.localeCompare(b.datefact),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Date recep.",
      dataIndex: "daterecep",
      key: "daterecep",
      align: "center",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <DatePicker.RangePicker
            style={{ marginBottom: 8, width: "100%" }}
            format="DD/MM/YYYY"
            value={
              selectedKeys[0]
                ? [dayjs(selectedKeys[0][0]), dayjs(selectedKeys[0][1])]
                : null
            }
            onChange={(dates) => {
              if (dates && dates[0] && dates[1]) {
                setSelectedKeys([[dates[0].format("YYYY-MM-DD"), dates[1].format("YYYY-MM-DD")]]);
              } else {
                setSelectedKeys([]);
              }
            }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Réinitialiser
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (!record.daterecep) return false;
        const [start, end] = value;
        const recordDate = moment(record.daterecep);
        return recordDate.isSameOrAfter(moment(start), "day") && recordDate.isSameOrBefore(moment(end), "day");
      },
      sorter: (a, b) => a.daterecep.localeCompare(b.daterecep),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Date Echéance.",
      dataIndex: "echeance",
      key: "echeance",
      align: "center",
      filters: [
        ...new Set(
          tableData
            .map((item) => item?.echeance && moment(item.echeance).year())
            .filter((year) => year)
        ),
      ]
        .sort((a, b) => b - a)
        .map((year) => ({ text: year, value: year })),
      onFilter: (value, record) =>
        record.echeance && moment(record.echeance).year() === value,
      sorter: (a, b) => a.echeance.localeCompare(b.echeance),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    ...(selectedOption !== "PP" && selectedOption !== "CC"
      ? [
        {
          title: "J retard.",
          dataIndex: "nbjours",
          key: "nbjours",
          align: "center",
          sorter: (a, b) => a.nbjours - b.nbjours,
        },
      ]
      : []),
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Montant
        </div>
      ),
      dataIndex: "montfact",
      key: "montfact",
      align: "right",
      sorter: (a, b) => a.montfact - b.montfact,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.montfact >= min; // Plus de 1,000,000
          return record.montfact >= min && record.montfact <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.montfact === parsedValue; // Recherche directe
      },
      render: (text) => {
        const amount = parseFloat(text);
        const color = amount < 0 ? "red" : ""; // Colorie en rouge si le montant est négatif
        return (
          <div style={{ paddingRight: 10, color: color }}>
            <strong>
              {formatNumberWithSeparator(text && amount !== 0 ? amount : "")}
            </strong>
          </div>
        );
      },
    },

    {
      title: "N° Frs",
      dataIndex: "numfourn",
      key: "numfourn",
      align: "center",
      sorter: (a, b) => a.numfourn.localeCompare(b.numfourn),
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
          <a
            style={{
              cursor: "pointer",
              color: "#1677ff",
              textDecoration: "none",
              fontWeight: 500,
              borderRadius: 4,
              padding: "2px 8px",
              transition: "background 0.2s",
              background: "#f4f8ff",
              display: "inline-block",
            }}
            onMouseOver={e => (e.currentTarget.style.background = "#e6f0ff")}
            onMouseOut={e => (e.currentTarget.style.background = "#f4f8ff")}
            onClick={() => {
              setFilteredData(tableData.filter(item => item.numfourn === record.numfourn));
            }}
          >
            {text}
          </a>
          <Tooltip title="Cliquer pour filtrer par ce fournisseur">
            <FilterOutlined
              style={{
                cursor: "pointer",
                color: "#1677ff",
                fontSize: 12,
                transition: "color 0.2s",
              }}
              onClick={() => {
                setFilteredData(tableData.filter(item => item.numfourn === record.numfourn));
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#0050b3";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#1677ff";
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Fournisseurs
        </div>
      ),
      dataIndex: "raisoc",
      key: "raisoc",
      filters: [
        ...new Set(
          tableData.map((item) => item?.raisoc).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      filterSearch: true,
      onFilter: (value, record) => record.raisoc === value,
      render: (text) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "left",
            paddingRight: 5,
            paddingLeft: 5,
          }}
        >
          {text}
        </div>
      ),
      sorter: (a, b) => a.raisoc.localeCompare(b.raisoc),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Spécialité
        </div>
      ),

      dataIndex: "intitule",
      key: "intitule",
      filters: [
        ...new Set(
          tableData.map((item) => item?.intitule).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.intitule === value,
      render: (text) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "left",
            paddingRight: 5,
            paddingLeft: 5,
          }}
        >
          {text}
        </div>
      ),
      sorter: (a, b) => a.intitule.localeCompare(b.intitule),
    },
    {
      title: "Mois Trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      sorter: (a, b) => a.datetrait.localeCompare(b.datetrait),
      filters: [
        ...new Set(
          tableData
            .map((item) => (item?.datetrait ? moment(item.datetrait).format("MMM.YYYY") : null))
            .filter((value) => value)
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) =>
        record.datetrait && moment(record.datetrait).format("MMM.YYYY") === value,
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >

          {text ? moment(text).format("MMM.YYYY") : ""}</div>

        /*  {moment(text).locale("fr").format("DD/MM/YYYY")} */

      ),
    },
  ];

  const conditionalColumns = getConditionalColumns();
  baseColumns.push(...conditionalColumns);

  baseColumns.push({
    title: "État",
    dataIndex: "etape",
    key: "etape",
    fixed: "right",
    className: "small-cell",
    ellipsis: true,
    align: "center",
    filters: [
      { text: "Non Échue", value: "NP" },
      { text: "Échue", value: "AP" },
      { text: "Compt.", value: "CC" },
      { text: "Payée", value: "PP" },
      { text: "Annulée", value: "NN" },
    ],
    onFilter: (value, record) => record.etape === value,
    sorter: (a, b) => a.etape.localeCompare(b.etape),
    render: (etape) => {
      let color = "";
      let text = "";
      switch (etape) {
        case "NP":
          color = "#e67e22";
          text = "Non Échue";
          break;
        case "AP":
          color = "#c0392b";
          text = "Échue";
          break;
        case "CC":
          color = "#1890ff";
          text = "Compt.";
          break;
        case "PP":
          color = "#1e8449";
          text = "Payée.";
          break;
        case "NN":
          color = "#4a6a6a";
          text = "Annulée.";
          break;
      }
      return (
        <div style={{ paddingLeft: 10 }}>
          <Tag color={color} key={etape}>
            {text}
          </Tag>
        </div>
      );
    },
  });

  const actionColumn = {
    title: (
      <div
        style={{ backgroundColor: "#010f1c", color: "white", padding: "1px" }}
      ></div>
    ),
    dataIndex: "actions",
    key: "actions",
    align: "center",

    fixed: "right",
    render: (text, record) => (
      <Space size="small">
        <Tooltip title="Modifier règlement">
          <EditOutlined
            style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
            onClick={() => openEditModal(record)}
          />
        </Tooltip>

        <Tooltip title="Annuler règlement">
          <MinusCircleOutlined
            style={{ cursor: "pointer", color: "#67f02e", marginRight: 8 }}
            onClick={() => confirmCancel(record)} // Confirmation avant d'annuler
          />
        </Tooltip>
      </Space>
    ),
  };

  if (selectedOption === "PP") {
    baseColumns.push(actionColumn);
  }

  const columns = baseColumns;

  const fetchSaisie = async (type) => {
    try {
      const journalsData = await reglementService.getSaisieReg();
      setJournalRegData(journalsData);
      setTypeReglementFourn(
        journalsData.filter((journal) => journal.type === type)
      );
    } catch (error) {
      notification.error({
        message: "Erreur lors de la récupération des journaux comptables",
        description: error.message,
      });
    }
  };

  const menu = (
    <Menu
      onClick={(e) => {
        // Appelle openModal avec le type de règlement sélectionné
        openModal(e.key);
      }}
    >
      <Menu.Item key="Virement">Virement</Menu.Item>
      <Menu.Item key="Chèque">Autres</Menu.Item>
    </Menu>
  );

  const openModal = (typeReglement) => {
    if (selectedRowKeys.length > 0) {
      const selectedRecords = tableData.filter((record) =>
        selectedRowKeys.includes(record.numenreg)
      );

      if (typeReglement === "Chèque") {
        const allSameFournisseur = selectedRecords.every(
          (record) => record.numfourn === selectedRecords[0].numfourn
        );
        if (!allSameFournisseur) {
          Modal.warning({
            title: "Sélection invalide",
            content:
              "Veuillez sélectionner des lignes avec le même fournisseur.",
          });
          return;
        }
      }

      const totalMontfact = selectedRecords.reduce((acc, record) => {
        return acc + parseFloat(record.montfact || 0);
      }, 0);

      setModalData({
        ...selectedRecords[0],
        type: typeReglement,
        selectedRecords,
        montfact: totalMontfact,
        numfactures: selectedRecords.length,
      });

      // Si "Virement", sélectionner l'option "V" et désactiver
      if (typeReglement === "Virement") {
        setSelectedTypeReglement("V");
        setIsTypeRegDisabled(true);
        form.setFieldsValue({
          typeReg: "V",
        });
      } else {
        // Si autre type, réinitialiser le champ et ne pas désactiver
        setSelectedTypeReglement(null);
        setIsTypeRegDisabled(false);
        form.setFieldsValue({
          typeReg: undefined, // Cela réinitialise le Select pour afficher le placeholder
        });
      }

      setModalVisible(true);
      loadParams();
      fetchSaisie();
    } else {
      notification.warning({
        message: "Sélection requise",
        description: "Veuillez sélectionner au moins une ligne.",
      });
    }
  };

  const openEditModal = (record) => {
    setIsEditMode(true); // Mode modification
    setModalData(record);
    setModalVisible(true);
    loadParams();
    fetchSaisie();

    // Initialiser les champs du formulaire
    form.setFieldsValue({
      typeReg: record.typereglmt,
      numReg: record.numreglmt,
      comptegen: record.compte_rattache,
    });

    // Mettre à jour le type de règlement sélectionné
    setSelectedTypeReglement(record.typereglmt);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setModalData(null);
    setSelectedTypeReglement(null);
    form.resetFields(["typeReg", "numReg", "comptegen"]);
    setSolde(0);
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      const selectedJournal = journalRegData.find(
        (journal) => journal.compte_rattache === values.comptegen
      );

      // Filtrer les factures ayant le même numreglmt que celui de la ligne sélectionnée en mode modification
      const facturesList = modalData?.numreglmt
        ? tableData.filter((item) => item.numreglmt === modalData.numreglmt)
        : selectedRowKeys.map((key) =>
          tableData.find((item) => item.numenreg === key)
        );

      const payload = {
        codeBque: selectedJournal ? selectedJournal.codej : null,
        comptegen: values.comptegen,
        dateReg: values.dateReg.toISOString(),
        datecompta: values.dateReg.toISOString(),
        datetrait: selectedDate.toISOString(),
        libReg: values.libReg,
        listFactures: facturesList,
        montantReg: montantReglement,
        numReg: values.numReg,
        typeReg: values.typeReg,
      };

      await reglementService.updateSaisieReg(payload);
      notification.success({ message: "Règlement enregistré avec succès" });

      // Réinitialisation des champs
      form.resetFields(["typeReg", "numReg", "comptegen"]);
      setSelectedTypeReglement(null);
      setSolde(0);

      setModalVisible(false);
      setModalData(null);
      fetchReglementations();
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'enregistrement du règlement",
      });
      console.error("Erreur lors de l'enregistrement du règlement :", error);
    }
  };

  const handleApayerReglement = async (record) => {
    try {
      const payload = selectedRowKeys.map(
        (key) => tableData.find((item) => item.numenreg === key).numenreg
      );
      await reglementService.apayerReglementFact(payload);
      notification.success({ message: "Règlement echue avec succès" });
      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'annulation du règlement",
      });
      console.error("Erreur lors de l'annulation du règlement :", error);
    }
  };

  const annulerApayerReglement = async (record) => {
    try {
      const payload = selectedRowKeys.map(
        (key) => tableData.find((item) => item.numenreg === key).numenreg
      );
      await reglementService.annulerApayerReglementFact(payload);
      notification.success({ message: "Règlement annulé avec succès" });
      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'annulation du règlement",
      });
      console.error("Erreur lors de l'annulation du règlement :", error);
    }
  };
  const handleValidCompta = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );

      // Vérification : au moins un comptegen vide ?
      const hasEmptyComptegen = selectedRows.some(row => !row.comptegen || row.comptegen === "");
      if (hasEmptyComptegen) {
        Modal.warning({
          title: "Attention",
          content: `Au moins une ligne sélectionnée n'a pas de compte général renseigné.
          Veuillez modifier le reglement des factures concernées avant de valider la comptabilisation.`,
        });
        return;
      }

      const payload = {
        comptas: comptaPreviewData,
        factures: selectedRows,
      };
      const data = await reglementService.addValidComptaReg(payload);
      setIsModalOpen(false);
      fetchReglementations();
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };
  const handleAnnulationComptabilisation = async (record) => {
    try {
      const payload = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );


      // Vérification : tous les numreglmt sont-ils identiques ?
      const allNumreglmt = payload.map(row => row.numreglmt);
      const firstNumreglmt = allNumreglmt[0];
      const allIdentical = allNumreglmt.every(num => num === firstNumreglmt);

      if (!allIdentical) {
        Modal.warning({
          title: "Attention",
          content: "Tous les règlements sélectionnés doivent avoir le même numéro de règlement (N° C/V).",
        });
        return;
      }

      const data = await reglementService.previewAnnulationComptaReg(payload);
      setAnnulationPreviewData(data);
      setIsAnnulationModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données d'annulation :",
        error
      );
    }
  };

  const handleValidAnnulationCompta = async () => {
    try {
      // Payload pour addAnnulationCompta
      const addPayload = annulationPreviewData;

      // Payload pour putAnnulationCompta
      const putPayload = annulationPreviewData.map((item) => item.numfactipm);

      await reglementService.addPreviewAnnulationComptaReg(addPayload);
      await reglementService.updateAnnulationCompta(putPayload);
      fetchReglementations();

      setIsAnnulationModalOpen(false);
    } catch (error) {
      console.error(
        "Erreur lors de la validation de l'annulation de la comptabilisation :",
        error
      );
    }
  };

  const handleCancelReglement = async (record) => {
    try {
      const payload = {
        ...record,
      };
      await reglementService.cancelSaisieReg(payload);
      notification.success({ message: "Règlement annulé avec succès" });
      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'annulation du règlement",
      });
      console.error("Erreur lors de l'annulation du règlement :", error);
    }
  };
  const handleRefresh = async () => {
    try {
      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'annulation du règlement",
      });
      console.error("Erreur lors de l'annulation du règlement :", error);
    }
  };





  const stateConfig = {
    NP: {
      isEditingEnabled: true,
      isPayingEnabled: true,
      isMassTransferEnabled: false,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
    AP: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: true,
      isAnRegEnabled: false,
      isRgFactEnabled: true,
      isOtherButtonsEnabled: true,
    },
    PP: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: true,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
    CC: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: true,
      isRgFactEnabled: false,
    },
    NN: {
      isEditingEnabled: true,
      isPayingEnabled: true,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
  };

  /*************  ✨ Windsurf Command 🌟  *************/
  const handleOptionChange = (e) => {
    const newOption = e.target.value;
    setSelectedOption(newOption);
    setSelectedRowKeys([]); // Réinitialiser la sélection des lignes
    setIsEditingEnabled(false);
    setIsPayingEnabled(false);
    setIsMassTransferEnabled(false);
    setIsComptaEnabled(false);
    setIsAnPayeEnabled(false);
    setIsAnRegEnabled(false);
    setIsRgFactEnabled(false);
    setIsOtherButtonsEnabled(false);

    if (newOption === "CC") {
      setSelectedYear(new Date().getFullYear().toString());
    } else {
      setSelectedYear('9999');
    }
  };
  /*******  486e023c-be4b-4156-bfa6-180f06485e37  *******/

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);

    const hasSelectedRows = newSelectedRowKeys.length > 0;
    if (hasSelectedRows) {
      const selectedState = stateConfig[selectedOption] || {};
      setIsEditingEnabled(selectedState.isEditingEnabled);
      setIsPayingEnabled(selectedState.isPayingEnabled);
      setIsMassTransferEnabled(selectedState.isMassTransferEnabled);
      setIsComptaEnabled(selectedState.isComptaEnabled);
      setIsAnPayeEnabled(selectedState.isAnPayeEnabled);
      setIsAnRegEnabled(selectedState.isAnRegEnabled);
      setIsRgFactEnabled(selectedState.isRgFactEnabled);
      setIsOtherButtonsEnabled(selectedState.isOtherButtonsEnabled);
    } else {
      setIsEditingEnabled(false);
      setIsPayingEnabled(false);
      setIsMassTransferEnabled(false);
      setIsComptaEnabled(false);
      setIsAnPayeEnabled(false);
      setIsAnRegEnabled(false);
      setIsRgFactEnabled(false);
      setIsOtherButtonsEnabled(false);
    }
  };

  const handlePrintClick = () => {
    fetchJournalBque();
    setIsPrintModalVisible(true);
  };

  const handlePrintModalOk = async () => {
    let docName = "ListeFactAPayer";
    const payload = selectedRowKeys;

    try {
      await journalCentralService.updatePrint(payload);

      switch (selectedReportType) {
        case "ListeFactAPayer":
          journalCentralService.printAPService(docName);
          break;
        case "FactureNonPayees":
          journalCentralService.printNPService(docName);
          break;
        case "Lettre_Cheque":
          docName = "Lettre_Cheque";
          journalCentralService.printChequeService(docName);
          break;
        case "Virement_Fournisseurs":
          docName = "Virement_Fournisseurs";
          journalCentralService.printVirementService(docName);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour des données :", error);
    }
  };

  const handlePrintModalCancel = () => {
    setIsPrintModalVisible(false);
    setSelectedReportType(null);
    form.resetFields();
  };

  const handleExportToExcel = async () => {
    console.log("handleExportToExcel called");
    const payload = selectedRowKeys;
    try {
      console.log("Payload:", payload);
      await journalCentralService.updatePrint(payload);
      console.log("Print updated");
      await journalCentralService.exportVirementMasse(selectedRowKeys);
      console.log("Export successful");
    } catch (error) {
      console.error("Erreur lors de l'exportation :", error);
    }
  };

  const handleCompteRattacheChange = async (value) => {
    try {
      const soldeData = await reglementService.getSoldeReg(value);
      setSolde(soldeData);
    } catch (error) {
      console.error("Erreur lors de la récupération du solde :", error);
    }
  };

  const columns1 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => (a.codej || "").localeCompare(b.codej || ""),
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      sorter: (a, b) =>
        (a.datecompta ? moment(a.datecompta).unix() : 0) -
        (b.datecompta ? moment(b.datecompta).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("DD/MM/YYYY") : ""}</div>
      ),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) =>
        (a.datetrait ? moment(a.datetrait).unix() : 0) -
        (b.datetrait ? moment(b.datetrait).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("MMM.YYYY") : ""}</div>
      ),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => (a.numpiece || "").localeCompare(b.numpiece || ""),
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => (a.numcheque || "").localeCompare(b.numcheque || ""),
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => (a.numfactipm || "").localeCompare(b.numfactipm || ""),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => (a.comptegen || "").localeCompare(b.comptegen || ""),
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) =>
        (a.comptetiers || "").localeCompare(b.comptetiers || ""),
    },
    {
      title: "Matricule",
      dataIndex: "matri",
      key: "matri",
      align: "center",
      sorter: (a, b) => (a.matri || "").localeCompare(b.matri || ""),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => (a.libelle || "").localeCompare(b.libelle || ""),
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      sorter: (a, b) => (a.debit || 0) - (b.debit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0
            ? formatNumberWithSeparator(parseFloat(text))
            : ""}
        </div>
      ),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => (a.credit || 0) - (b.credit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0
            ? formatNumberWithSeparator(parseFloat(text))
            : ""}
        </div>
      ),
    },
  ];
  const totalDebit = annulationPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit = annulationPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde0 = totalDebit - totalCredit;

  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  const handleComptabiliser = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );

      console.log("Selected Rows: ", selectedRows); // Debugging line

      const data = await reglementService.ComptaRegPreviewCompta(selectedRows);
      console.log("Compta Preview Data: ", data); // Debugging line

      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };

  const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };

  const allRowKeys = filteredData.map((record) => record.numenreg);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: onSelectChange, // Utilisation de la fonction nommée

    selections: [
      {
        key: "select-all",
        text: "Sélectionner toutes les lignes",
        onSelect: () => {
          const allKeys = filteredData.map((item) => item.numenreg);
          setSelectedRowKeys(allKeys);
          onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
        },
      },
      {
        key: "clear-selection",
        text: "Désélectionner toutes les lignes",
        onSelect: () => {
          setSelectedRowKeys([]);
          onSelectChange([]); // Appel explicite avec un tableau vide
        },
      },
    ],

    getCheckboxProps: (record) => ({
      name: record.numenreg,
    }),
  };

  useEffect(() => {
    if (modalData) {
      // Si `selectedRecords` existe, utiliser les données pour générer `libReg`
      const libRegValue = modalData.selectedRecords
        ? `RGLMT Facture N° ${modalData.selectedRecords
          .map((record) => record.numenreg)
          .join(" - ")} / ${modalData?.raisoc}`
        : `RGLMT Facture N° ${modalData.numenreg || ""} / ${modalData.raisoc || ""
        }`; // Fallback pour l'édition

      form.setFieldsValue({
        libReg: libRegValue,
      });
    }
  }, [modalData, form]);

  const handleExport = () => {
    // Préparer les données à partir de `filteredData`
    const exportData = filteredData.map((row) => ({
      "Numéro Enreg": row.numenreg || "",
      "Numéro Fact. Frs": row.numfact || "",
      "Date Facture": row.datefact
        ? moment(row.datefact).format("DD/MM/YYYY")
        : "",
      "Date Recep": row.daterecep
        ? moment(row.daterecep).format("DD/MM/YYYY")
        : "",
      "Date Echéance": row.echeance || "",
      "Montant": row.montfact || 0,
      "Fournisseur": row.raisoc || "",
      "Spécialité": row.intitule || "",
      "Mois Traitement": row.datetrait
        ? moment(row.datetrait).format("MMM-YYYY")
        : "",
      "Date Reg.": row.datereglmt,
      "Type Reg.": row.typereglmt || "",
      "Numéro Reg": row.numreglmt || "",
      "code Banque": row.codebque || "",
      "compta_by.": row.compta_by || "",
      "created_by": row.created_by || "",
    }));

    // Vérifier si les données sont valides
    if (exportData.length === 0) {
      notification.warning({
        message: "Aucune donnée à exporter",
      });
      return;
    }

    try {
      // Créer la feuille Excel
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();

      // Ajouter la feuille au classeur
      XLSX.utils.book_append_sheet(workbook, worksheet, "Règlements");

      // Télécharger le fichier Excel
      XLSX.writeFile(workbook, "Reglements_Fournisseurs.xlsx");

      notification.success({
        message: "Exportation réussie",
        description: "Les données ont été exportées avec succès.",
      });
    } catch (error) {
      console.error("Erreur lors de l'exportation :", error);
      notification.error({
        message: "Erreur d'exportation",
        description: "Une erreur s'est produite lors de l'exportation.",
      });
    }
  };


  const gestionMenu1 = (
    <Menu>
      <Menu.Item icon={<SyncOutlined />} onClick={handleRefresh} key="1">
        Actualiser
      </Menu.Item>
      <Menu.Item
        icon={<CheckCircleOutlined />}
        disabled={!isPayingEnabled}
        key="2"
        onClick={handleApayerReglement}
      >
        A payer
      </Menu.Item>
      <Menu.Item
        icon={<UndoOutlined />}
        disabled={!isAnPayeEnabled}
        onClick={annulerApayerReglement}
        key="3"
      >
        Annuler A payer
      </Menu.Item>
      <Menu.Item
        icon={<UndoOutlined />}
        onClick={handleAnnulationComptabilisation}
        disabled={!isAnRegEnabled}
        key="4"
      >
        Annuler Comptabilisation Reg.
      </Menu.Item>
      <Menu.Item icon={<ExportOutlined />} onClick={handleExport} key="5">
        Exporter
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <b>
        {rowCount} Facture(s) - {formatNumberWithSeparator(totalAmount)}{" "}
      </b>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={10} lg={10} style={{ display: "flex" }}>
              <Row gutter={8}>
                <Col xs={6}>
                  <Space direction="vertical" style={{ textAlign: "left" }}>
                    <label style={{ fontSize: 12 }}>Exercice</label>
                    <Select
                      className="select-colored-accent"
                      style={{
                        width: "80px",
                        "--select-accent": "#1890ff",
                        "--select-accent-bg": "#e6f4ff",
                        "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                      }}
                      onChange={handleYearChange}
                      value={selectedYear}
                    >
                      <Select.Option value="9999">Tous</Select.Option>
                      {years.map((year) => (
                        <Option key={year} value={year}>
                          {year}
                        </Option>
                      ))}
                    </Select>
                  </Space>
                </Col>

                <Col xs={10}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Input
                      className="search-input-highlight"
                      placeholder="Rechercher..."
                      allowClear
                      prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                      style={{
                        width: 300,
                        marginTop: "30px",
                      }}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                    {filteredData.length > 0 &&
                      filteredData.length < tableData.length &&
                      // Vérifie si le filtre numfourn est appliqué
                      filteredData.every(row => row.numfourn === filteredData[0].numfourn) ? (
                      <Tooltip title="Réinitialiser le filtre fournisseur">
                        <Button
                          icon={<SyncOutlined />}
                          style={{ marginLeft: 8, marginTop: 30, minWidth: 40, padding: "0 16px", backgroundColor: "#ffa500" }}
                          onClick={() => setFilteredData(tableData)}
                        />
                      </Tooltip>
                    ) : null}
                  </div>
                </Col>


              </Row>
            </Col>
            <Col xs={24} sm={14} lg={14}>
              <Row justify="end">
                <Col span={24} style={{ textAlign: "right" }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: "1rem", justifyContent: "flex-end" }}>
                    {[
                      { value: "TT", label: "Tout", color: "#0f8b9e", colorLight: "#1abc9c" },
                      { value: "NP", label: "Non Échue", color: "#e67e22", colorLight: "#f39c12" },
                      { value: "AP", label: "Échue", color: "#c0392b", colorLight: "#e74c3c" },
                      { value: "PP", label: "Réglée", color: "#1e8449", colorLight: "#27ae60" },
                      { value: "CC", label: "Comptabilisée", color: "#1890ff", colorLight: "#0097e6" },
                      { value: "NN", label: "Annulée", color: "#4a6a6a", colorLight: "#6c9494" },
                    ].map((item) => (
                      <button
                        key={item.value}
                        className={item.value === "NN" ? "buttonCompta" : undefined}
                        onClick={() => handleOptionChange({ target: { value: item.value } })}
                        style={{
                          padding: "6px 16px",
                          borderRadius: 20,
                          border: "none",
                          cursor: "pointer",
                          fontSize: 13,
                          fontWeight: 500,
                          transition: "all 0.3s ease",
                          background:
                            selectedOption === item.value
                              ? `linear-gradient(135deg, ${item.color} 0%, ${item.colorLight} 100%)`
                              : "#f0f0f0",
                          color: selectedOption === item.value ? "#fff" : "#595959",
                          boxShadow:
                            selectedOption === item.value
                              ? `0 3px 10px ${item.color}66`
                              : "0 1px 3px rgba(0, 0, 0, 0.1)",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#e0e0e0";
                            e.currentTarget.style.transform = "translateY(-1px)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#f0f0f0";
                            e.currentTarget.style.transform = "translateY(0)";
                          }
                        }}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                </Col>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Space
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    {/* <Button
                      icon={<FileExcelOutlined />}
                      className="buttonImprim"
                      disabled={!isMassTransferEnabled}
                      onClick={handleExportToExcel}
                    >
                      Virement de Masse
                    </Button> */}

                    {/* <Dropdown
                      overlay={
                        <Menu style={{ minWidth: 230, borderRadius: 8, padding: "4px 0" }}>
                          <div style={{ padding: "6px 16px 4px", fontSize: 11, color: "#8c8c8c", fontWeight: 600, letterSpacing: 0.5 }}>
                            SÉLECTION ({currentTableData.length} lignes visibles)
                          </div>
                          <Menu.Divider style={{ margin: "4px 0" }} />
                          <Menu.Item
                            key="select-all"
                            icon={<CheckSquareOutlined style={{ color: "#1677ff", fontSize: 15 }} />}
                            style={{ padding: "8px 16px", fontWeight: 500 }}
                            onClick={() => {
                              const allKeys = currentTableData.map((item) => item.numenreg);
                              setSelectedRowKeys(allKeys);
                              onSelectChange(allKeys);
                            }}
                          >
                            Sélectionner tout
                          </Menu.Item>
                          <Menu.Item
                            key="deselect-all"
                            icon={<MinusSquareOutlined style={{ color: "#ff4d4f", fontSize: 15 }} />}
                            style={{ padding: "8px 16px", fontWeight: 500 }}
                            onClick={() => {
                              setSelectedRowKeys([]);
                              onSelectChange([]);
                            }}
                          >
                            Désélectionner tout
                          </Menu.Item>
                        </Menu>
                      }
                      trigger={["click"]}
                    >
                      <Button className="buttonSelection">
                        Sélection <DownOutlined />
                      </Button>
                    </Dropdown> */}


                    <Button
                      icon={<MoreOutlined />}
                      className="buttonEdition"
                      disabled={!isEditingEnabled}
                      onClick={handlePrintClick}
                    >
                      Édition
                    </Button>

                    <Dropdown overlay={menu} disabled={!isRgFactEnabled}>
                      <Button className="buttonRegle">
                        Régler Facture(s) <DownOutlined />
                      </Button>
                    </Dropdown>

                    <Button
                      icon={<CalculatorOutlined />}
                      className="buttonCompta"
                      disabled={!isComptaEnabled}
                      onClick={handleComptabiliser}
                    >
                      Comptabiliser
                    </Button>
                    <Dropdown overlay={gestionMenu1} trigger={["click"]}>
                      <Button
                        icon={<MoreOutlined />}
                      //disabled={!isOtherButtonsEnabled}
                      />
                    </Dropdown>
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>


          <Card bordered={false}>
            <Table
              loading={loading}
              rowSelection={rowSelection}
              rowKey={(record) => record.numenreg}
              rowClassName={(record) =>
                selectedRowKeys.includes(record.numenreg) ? "selected-row" : ""
              }
              scroll={{ x: true }}
              //  className="custom-header2-table"
              className="custom-header2-table my-custom-table"
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              bordered
              pagination={{
                pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
                showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
                pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
                onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
              }}
              columns={columns}
              showSorterTooltip={false}
              dataSource={filteredData}
              onChange={handleTableChange}

              title={() => {
                // Calcul du nombre de lignes sélectionnées et du total des montants sélectionnés
                const selectedRows = filteredData.filter(row => selectedRowKeys.includes(row.numenreg));
                const selectedCount = selectedRows.length;
                const selectedTotal = selectedRows.reduce((sum, row) => sum + parseFloat(row.montfact || 0), 0);

                return (
                  <div style={{ display: "flex", justifyContent: "flex-start", gap: 32 }}>
                    <span>
                      <strong>Lignes sélectionnées :</strong> {selectedCount}
                    </span>
                    <span>
                      <strong>Total sélectionné :</strong> {formatNumberWithSeparator(selectedTotal)} CFA
                    </span>
                  </div>
                );
              }}

            />
          </Card>
        </Col>
      </Row>
      <DraggableModal
        title={
          isEditMode
            ? "Modification Règlement Facture Fournisseur de Soins"
            : "Règlement Facture Fournisseur de Soins"
        }
        open={modalVisible}
        maskClosable={false}
        onCancel={handleModalCancel}
        onOk={handleModalOk}
        style={{ top: 20 }}
        width={1000}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="typeReg"
                label="Type Règlement"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  placeholder="- Sélectionner -"
                  onChange={handleTypeReglementChange}
                  value={selectedTypeReglement}
                  disabled={isTypeRegDisabled} // Désactive si "Virement" est sélectionné
                >
                  <Option value="V">Virement</Option>
                  <Option value="C">Chèque</Option>
                  <Option value="A">Compte Avance</Option>
                  <Option value="E">Espèce</Option>
                  <Option value="T">Transfert</Option>
                </Select>
              </Form.Item>
            </Col>
            {(selectedTypeReglement === "V" ||
              selectedTypeReglement === "C") && (
                <Form.Item
                  name="comptegen"
                  label="Banque"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un type de règlement",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 180 }}
                    onChange={handleCompteRattacheChange}
                  >
                    {journalRegData &&
                      journalRegData
                        .filter((journal) => journal.type === "BANQUE")
                        .map((journal) => (
                          <Option
                            key={journal.compte_rattache}
                            value={journal.compte_rattache}
                          >
                            {` ${journal.libelle}`}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>
              )}
            {selectedTypeReglement === "A" && (
              <Form.Item
                name="comptegen"
                label="Compte Avance"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.type === "AVANCE")
                      .map((journal) => (
                        <Option key={journal.compte_rattache} value={journal.compte_rattache}>
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}
            {selectedTypeReglement === "T" && (
              <Form.Item
                label="Transfert"
                name="comptegen"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.type === "TRANSFERT")
                      .map((journal) => (
                        <Option
                          key={journal.compte_rattache}
                          value={journal.compte_rattache}
                        >
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}

            <Col span={6}>
              <Form.Item
                name="numReg"
                label={`N° ${selectedTypeReglement
                  ? typeReglementLabels[selectedTypeReglement]
                  : ""
                  }`}
                rules={[
                  { required: true, message: "Numéro de facture requis" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="dateReg"
                label="Date Règlement"
                initialValue={dayjs()}
                rules={[
                  { required: true, message: "Date de règlement requise" },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  disabledDate={(current) => current && current > dayjs().endOf('day')}
                />
              </Form.Item>
            </Col>
          </Row>
          {/*  {!isEditMode && (  /* )} */}

          <Row gutter={16}>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}
              >
                <span>
                  <strong>Montant(s) </strong> {modalData?.numfactures}{" "}
                  <strong>facture(s):</strong> {modalData?.montfact}
                </span>
                {/* {!isEditMode && ( )} */}
                <span>
                  <strong>Solde Banque ce jour: </strong>
                  <strong color="#59e60e">{solde?.solde || 0}</strong>
                </span>
              </div>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Row gutter={16}>
                <Col span={20}>
                  <Form.Item name="datetrait" label="Mois traitement">
                    <Input
                      value={selectedDate}
                      style={{ width: "100%" }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <div style={{ paddingTop: "30px" }}>
                    <Popover
                      placement="bottomCenter"
                      content={
                        <DatePicker
                          format="MMM-YYYY"
                          picker="month"
                          value={selectedDate}
                          onChange={(date) => setSelectedDate(date)}
                        />
                      }
                      trigger="click"
                    >
                      <Button icon={<CalendarOutlined />} />
                    </Popover>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row gutter={16}>
                {modalData?.selectedRecords?.map((record, index) => (
                  <Col span={8} key={index} style={{ marginBottom: 16 }}>
                    <Space direction="vertical" style={{ textAlign: "left" }}>
                      <strong>Facture N° {record.numenreg}</strong>
                      <InputNumber
                        value={
                          record.montant_reglmt ||
                          record.montfact/*  ||
                          montantReglement */
                        }
                        onChange={(value) => {
                          const updatedRecords = modalData.selectedRecords.map(
                            (r, i) =>
                              i === index ? { ...r, montant_reglmt: value } : r
                          );
                          setModalData({
                            ...modalData,
                            selectedRecords: updatedRecords,
                          });
                        }}
                        style={{ width: "150px" }}
                      />
                    </Space>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="libReg"
                label="Libellé"
                rules={[
                  { required: true, message: "Veuillez entrer un libellé" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </DraggableModal>

      <DraggableModal
        title="Edition"
        open={isPrintModalVisible}
        onOk={handlePrintModalOk}
        onCancel={handlePrintModalCancel}
        width={800}
        style={{ top: 20 }}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handlePrintModalCancel}>
            Fermer
          </Button>,
          <Button key="submit" type="primary" onClick={handlePrintModalOk}>
            Imprimer
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="edition" label="Edition">
            <Select
              bordered={false}
              style={{ borderBottom: "1px solid black" }}
              onChange={setSelectedReportType}
            >
              <Option value="ListeFactAPayer">Facture à Payer</Option>
              <Option value="FactureNonPayees">Facture non Payées</Option>
              <Option value="Lettre_Cheque">Lettre Chèque</Option>
              <Option value="Virement_Fournisseurs">Ordre de Virement</Option>
            </Select>
          </Form.Item>
          {(selectedReportType === "Lettre_Cheque" ||
            selectedReportType === "Virement_Fournisseurs") && (
              <Form.Item label="Banque">
                <Select
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303", width: "100%" }}
                >
                  {journalBqueData &&
                    journalBqueData
                      .filter((journal) => journal.type === "BANQUE")
                      .map((journal) => (
                        <Option key={journal.codej} value={journal.codej}>
                          {`${journal.codej} - ${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}
        </Form>
      </DraggableModal>

      <DraggableModal
        title="Aperçu écritures au journal"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel(
                prepareDataForExport(comptaPreviewData),
                "Aperçu Ecriture au Journal.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde1 !== 0}
            onClick={handleValidCompta}
          >
            Valider
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
            // y: "240px",
          }}
          className="custom-header2-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>
                  Total Débit : {formatNumberWithSeparator(totalDebit1)}
                </strong>
                <strong>
                  Total Crédit : {formatNumberWithSeparator(totalCredit1)}
                </strong>
                <strong> Solde : {formatNumberWithSeparator(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </DraggableModal>
      <DraggableModal
        title="Annulation Comptabilisation"
        open={isAnnulationModalOpen}
        onCancel={() => setIsAnnulationModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsAnnulationModalOpen(false)}
          >
            Annuler
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde !== 0}
            onClick={handleValidAnnulationCompta}
          >
            Valider
          </Button>,
        ]}
        width={1500}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          pagination={false}
          className="custom-header2-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          scroll={{
            x: true,
          }}
          showSorterTooltip={false}
          dataSource={annulationPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>
                  Total Débit : {formatNumberWithSeparator(totalDebit)}
                </strong>

                <strong>
                  Total Crédit : {formatNumberWithSeparator(totalCredit)}
                </strong>

                <strong> Solde : {formatNumberWithSeparator(solde0)}</strong>
              </Space>
            </div>
          )}
        />
      </DraggableModal>
    </div>
  );
};

export default ReglementFournSoins;
